var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "padlock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.96,
    height: 15,
    viewBox: "0 0 15.96 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M12.844,18.375H4.406A1.408,1.408,0,0,1,3,16.969V10.406A1.408,1.408,0,0,1,4.406,9h8.437a1.408,1.408,0,0,1,1.406,1.406v6.563A1.408,1.408,0,0,1,12.844,18.375ZM4.406,9.938a.469.469,0,0,0-.469.469v6.563a.469.469,0,0,0,.469.469h8.437a.469.469,0,0,0,.469-.469V10.406a.469.469,0,0,0-.469-.469Z",
    transform: "translate(-3 -3.375)",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M13.031,6.563a.469.469,0,0,1-.469-.469V3.75a2.812,2.812,0,1,0-5.625,0V6.094a.469.469,0,1,1-.937,0V3.75a3.75,3.75,0,1,1,7.5,0V6.094A.469.469,0,0,1,13.031,6.563Z",
    transform: "translate(2.46)",
    fill: "#767676"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M11.25,15.5a1.25,1.25,0,1,1,1.25-1.25A1.251,1.251,0,0,1,11.25,15.5Zm0-1.562a.313.313,0,1,0,.313.312A.313.313,0,0,0,11.25,13.937Z",
    transform: "translate(-5.625 -4.875)",
    fill: "#767676"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M11.719,18.406a.469.469,0,0,1-.469-.469V16.219a.469.469,0,0,1,.938,0v1.719A.469.469,0,0,1,11.719,18.406Z",
    transform: "translate(-6.094 -5.906)",
    fill: "#767676"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.a88e6a690d4e3d8db4c9c7303902cab4.svg";
export { ForwardRef as ReactComponent };